"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6984],{

/***/ 46984:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(68777);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21608);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(31555);
/* harmony import */ var react_html_parser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30653);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Title__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93264);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);









var RandomSliderServices = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(2013), __webpack_require__.e(7724), __webpack_require__.e(1118), __webpack_require__.e(1042)]).then(__webpack_require__.bind(__webpack_require__, 81875));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(81875)];
    }
  }
});

var MyComponent = function MyComponent(_ref) {
  var _services_data$posts, _services_data$sectio, _services_data$sectio2, _services_data$sectio3, _services_data$sectio4, _services_data$sectio5;

  var services_data = _ref.services_data,
      id = _ref.id,
      offset = _ref.offset,
      padding = _ref.padding;
  var services_list = services_data === null || services_data === void 0 ? void 0 : (_services_data$posts = services_data.posts) === null || _services_data$posts === void 0 ? void 0 : _services_data$posts.list;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(StyledComponent, {
      id: id,
      offset: offset,
      className: "".concat(padding ? padding : 'home-blue-bg-info '),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            md: 4,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_Title__WEBPACK_IMPORTED_MODULE_3__["default"], {
              text: (services_data === null || services_data === void 0 ? void 0 : (_services_data$sectio = services_data.section_data) === null || _services_data$sectio === void 0 ? void 0 : _services_data$sectio.title) && (services_data === null || services_data === void 0 ? void 0 : (_services_data$sectio2 = services_data.section_data) === null || _services_data$sectio2 === void 0 ? void 0 : _services_data$sectio2.title),
              fontSize: '44',
              fontWeight: '400',
              lineHeight: '56'
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            md: {
              span: 7,
              offset: 1
            },
            children: services_data !== null && services_data !== void 0 && (_services_data$sectio3 = services_data.section_data) !== null && _services_data$sectio3 !== void 0 && _services_data$sectio3.description ? (0,react_html_parser__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(services_data === null || services_data === void 0 ? void 0 : (_services_data$sectio4 = services_data.section_data) === null || _services_data$sectio4 === void 0 ? void 0 : _services_data$sectio4.description) : ''
          })]
        })
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(RandomSliderServices, {
      desc: services_data === null || services_data === void 0 ? void 0 : (_services_data$sectio5 = services_data.section_data) === null || _services_data$sectio5 === void 0 ? void 0 : _services_data$sectio5.short_desc,
      Data: services_list,
      offset: offset
    })]
  });
};

var StyledComponent = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].section.withConfig */ .ZP.section.withConfig({
  displayName: "Services__StyledComponent",
  componentId: "sc-8sdcmq-0"
})(["position:relative;background:#f2f2f2;padding-top:260px;padding-bottom:470px;background-image:url('images/static/servicesbg.webp');background-repeat:no-repeat;background-size:cover;background-position:center;@media(max-width:768px){padding-bottom:250px;}img{position:absolute;top:0;left:0;right:0;width:100%;height:100%;object-fit:cover;}ol{margin:0 0 70px;padding-left:0;@media(max-width:768px){margin-bottom:40px;}li{font-size:20px;line-height:24px;font-weight:500;color:#3C3C3B;p{font-size:20px;line-height:24px;font-weight:500;color:#3C3C3B;margin:0 !important;}padding:0px 0 25px 50px;z-index:50;position:relative;counter-increment:count;border-bottom:1px solid rgba(198,198,198,0.5);margin-bottom:25px;&:first-child{padding-top:0;}&:last-child{padding-bottom:0;border-bottom:0;}&:first-child:before{margin-top:0;}&:last-child:before{margin-bottom:0;}&:before{content:counter(count,upper-alpha);position:absolute;height:28px;width:28px;margin:0;font-size:12px;line-height:20px;font-weight:500;border:1px solid #978C21;background-color:#978C21;border-radius:50%;color:white;top:-4px;left:0px;display:flex;align-items:center;justify-content:center;}}}p{font-size:28px;line-height:36px;font-weight:300;color:#3C3C3B;margin-top:70px;}@media (max-width:767px){padding-top:120px;padding-bottom:540px;h2{margin-bottom:55px;}}"]);
/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.memo(MyComponent));

/***/ })

}]);